'use client';

import { useState, useEffect } from 'react';

interface ContactHeroProps {
  className?: string;
}

const ContactHero = ({ className = '' }: ContactHeroProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <section className={`relative min-h-[60vh] overflow-hidden bg-black ${className}`}>
        <div className="absolute inset-0">
          <img
            src="/our-story-image.png"
            alt="Contact us"
            className="w-full h-full object-cover scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        </div>
        <div className="relative min-h-[60vh] flex items-center py-24 lg:py-32">
          <div className="w-full px-8 lg:px-20 max-w-[1400px] mx-auto">
            <div className="max-w-4xl space-y-6">
              <h1 className="font-headline text-5xl lg:text-7xl font-normal leading-[0.95] text-white tracking-tight">
                Let's Create Your
                <span className="block font-normal mt-2">Dream Home Together</span>
              </h1>
              <p className="text-lg lg:text-xl text-white/80 leading-relaxed max-w-2xl font-normal">
                Begin your journey to a beautifully designed space that reflects your unique style and cultural heritage.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={`relative min-h-[80vh] overflow-hidden bg-black ${className}`}>
      <div className="absolute inset-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1c23e77b4-1764661943205.png"
          alt="Contact us"
          className="w-full h-full object-cover scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      </div>

      <div className="relative min-h-[100vh] flex items-center py-12 md:py-16 lg:py-32">
        <div className="w-full px-4 md:px-8 lg:px-20 max-w-[1400px] mx-auto">
          <div className="max-w-4xl space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full bg-white/10 backdrop-blur-xl border border-white/20">
              <div className="w-1.5 h-1.5 bg-white rounded-full" />
              <span className="text-xs font-medium text-white/90 tracking-widest uppercase">
                Get In Touch
              </span>
            </div>

            <h1 className="font-headline text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-normal leading-tight md:leading-[0.95] text-white tracking-tight">
              Let's Create Your
              <span className="block font-normal mt-2">Dream Home Together</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-white/80 leading-relaxed max-w-2xl font-normal">
              Begin your journey to a beautifully designed space that reflects your unique style and cultural heritage. Our team is ready to bring your vision to life.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;